import { endpoints } from '../endpoints';
import { ThunkAction } from '../_commons/thunks.common';
import { Api } from '../_commons/http';
import { JobOffersActions } from './jobOffers.actions';
import { JobOfferView } from './jobOffers.dto';
import { convertApiJobOfferToSchema } from './jobOffers.schema';

export class JobOffersThunks {
    static getJobOffer = (id: string): ThunkAction => async dispatch => {
        dispatch(JobOffersActions.getJobOfferStarted());

        const { data, status, error } = await Api.get<JobOfferView>(`${endpoints.jobOffers}/${id}`);

        if (status === 200 && data) {
            const parsed = convertApiJobOfferToSchema(data);

            dispatch(
                JobOffersActions.getJobOfferFinished({
                    id: parsed.jobOfferId,
                    offer: parsed.jobOffer
                })
            );
        } else {
            dispatch(JobOffersActions.getJobOfferFailed(error as string, status));
        }
    };
}
